import {getUrl} from "../../../constants/urls";

const useListAddressURL = () => {
  const addressURL = getUrl("getAddress");

  return {addressURL};
};

export default useListAddressURL;
